import * as $ from "jquery";
import '@progress/kendo-ui/js/kendo.grid';
import '@progress/kendo-ui/js/kendo.upload';
import '@progress/kendo-ui/js/kendo.button';
import '@progress/kendo-ui/js/kendo.datetimepicker';
import '@progress/kendo-ui/js/kendo.splitter';
import '@progress/kendo-ui/js/kendo.filtercell';
import '@progress/kendo-ui/js/kendo.dialog';
import '@progress/kendo-ui/js/kendo.router';
import '@progress/kendo-ui/js/kendo.multiselect';
import '@progress/kendo-ui/js/kendo.notification';
import '@progress/kendo-ui/js/kendo.tooltip';
//import '@progress/kendo-ui/js/kendo.web';
import '@progress/kendo-ui/css/web/kendo.common-office365.css';
import '@progress/kendo-ui/css/web/kendo.office365.custom.css';
//import '../less/kendo/office365.css'

(window as any).jQuery = (window as any).$ = $;
(window as any).kendo = kendo;


// WEBPACK FOOTER //
// ./js/kendo-shim.ts